import { DialogHeader } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { TicketMinus } from 'lucide-react'
import { ErrorMessage } from './error-message'
import { PrimaryButton } from './primary-button'
import { StepHeader } from './step-header'
import { StepTitleSection } from './step-title-section'

type InviteStepProps = {
	inviteCode: string
	setInviteCode: (value: string) => void
	onSubmit: () => void
	isLoading: boolean
	error: string | null
}

export function InviteStep({
	inviteCode,
	setInviteCode,
	onSubmit,
	isLoading,
	error,
}: InviteStepProps) {
	return (
		<>
			<DialogHeader>
				<div className="flex flex-col gap-[32px]">
					<StepHeader showBack={false} />
					<StepTitleSection
						title="Enter invite code"
						description="Chance is currently invite-only."
					/>
				</div>
			</DialogHeader>

			<div className="flex flex-col gap-[24px]">
				<div className="relative">
					<TicketMinus className="-translate-y-1/2 absolute top-[24px] left-3 size-[20px] text-brand-gray-secondary" />
					<Input
						type="text"
						placeholder="Enter your invite code"
						value={inviteCode}
						onChange={e => setInviteCode(e.target.value)}
						className="h-[48px] rounded-[12px] border border-brand-gray bg-brand-dark py-[12px] pl-[37px] font-normal text-[16px] text-brand-gray-secondary leading-[100%] placeholder:text-brand-gray-secondary"
						autoFocus
						onKeyDown={e => e.key === 'Enter' && onSubmit()}
					/>
				</div>

				<ErrorMessage error={error} />

				<PrimaryButton
					onClick={onSubmit}
					disabled={isLoading || !inviteCode.trim()}
					isLoading={isLoading}
				>
					Continue
				</PrimaryButton>
			</div>
		</>
	)
}
